import calculationCosts from './calculationCosts'
import machines from './machines'
import manualWorks from './manualWorks'
import materials from './materials'
import productionProcesses from './productionProcesses'
import productionSites from './productionSites'
import products from './products'
import rubberRegistry from './rubberRegistry'
import tools from './tools'

const messages = {
    root: {
        pageTitle: 'Konfiguracje',
        menuTitle: 'Konfiguracje'
    },
    materials: materials.messages,
    productionProcesses: productionProcesses.messages,
    machines: machines.messages,
    tools: tools.messages,
    productionSites: productionSites.messages,
    products: products.messages,
    rubberRegistry: rubberRegistry.messages,
    calculationCosts: calculationCosts.messages,
    manualWorks: manualWorks.messages
}

export default {
    messages: messages,
    locale: 'pl'
}
